type ClassNamesMap = Record<string, string>;

export const useMergedClassNames = (
  defaultClasses: ClassNamesMap,
  overrides?: Partial<ClassNamesMap>
) => {
  return Object.keys(defaultClasses).reduce((acc, key) => {
    acc[key] = `${defaultClasses[key]} ${overrides?.[key] ?? ''}`.trim();
    return acc;
  }, {} as ClassNamesMap);
};
